import { render } from "./massive-dependents-incorporation-form.vue?vue&type=template&id=e9d8815e"
import script from "./massive-dependents-incorporation-form.vue?vue&type=script&lang=js"
export * from "./massive-dependents-incorporation-form.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__